import React from "react";
import { useModal } from "@Contexts/ModalContext";
import { ReactComponent as ArrowLeft } from "@Icons/payments/ArrowLeft.svg";
import { useTranslation } from "react-i18next";

const ChoosePayment = () => {
  const { t } = useTranslation();
  const { content, closeModal } = useModal();
  const { onChange, availablePaymentProviders } = content;

  return (
    <div className="flex h-[90vh] flex-col space-y-8 sm:h-full">
      <div className="relative flex justify-center">
        <button onClick={closeModal}>
          <ArrowLeft className="absolute left-2 top-0" />
        </button>
        <p>{t("payment_method")}</p>
      </div>
      <div className="flex flex-col items-center space-y-3">
        {availablePaymentProviders?.map((provider) => (
          <button
            key={provider.paymentType}
            className="flex w-full items-center space-x-3 rounded-xl border p-4 lg:max-w-[390px]"
            onClick={() => {
              onChange(provider.paymentType);
              closeModal();
            }}
          >
            <img src={provider.img} alt={provider.text} className="h-7" />
            <p>{provider.text}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChoosePayment;
